"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _emotionTheming = require("emotion-theming");

var _SquareBorderButton = _interopRequireDefault(require("../../Button/SquareBorderButton"));

var _NoData = require("./NoData.styles");

var NoData = function NoData(_ref) {
  var theme = _ref.theme,
      label = _ref.label,
      button = _ref.button,
      colSpan = _ref.colSpan;
  return _react.default.createElement("tr", null, _react.default.createElement("td", {
    colSpan: colSpan
  }, _react.default.createElement("div", {
    className: (0, _NoData.containerStyles)()
  }, _react.default.createElement("h2", {
    className: (0, _NoData.labelStyles)(theme)
  }, label), !(0, _isEmpty.default)(button) && _react.default.createElement(_SquareBorderButton.default, button))));
};

NoData.propTypes = {
  theme: _propTypes.default.shape({}).isRequired,
  label: _propTypes.default.string.isRequired,
  button: _propTypes.default.shape({}).isRequired,
  colSpan: _propTypes.default.number.isRequired
};

var _default = (0, _emotionTheming.withTheme)(NoData);

exports.default = _default;